function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#008E00",
  fillRule: "nonzero",
  d: "M9.5 0C4.258 0 0 4.258 0 9.5S4.258 19 9.5 19 19 14.742 19 9.5 14.742 0 9.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.025 12.182l-1.91-1.91a.3.3 0 010-.423l.99-.99a.3.3 0 01.425 0l1.91 1.909 4.03-4.03a.3.3 0 01.424 0l.99.99a.3.3 0 010 .423l-5.233 5.233a.3.3 0 01-.424 0l-1.202-1.202z"
}));

var SvgValid = function SvgValid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/valid.444ca6e4.svg";
export { SvgValid as ReactComponent };